var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import React, { Component } from 'react';
import { withContext } from "../../componentWrappers";
import { advancedSort } from "../../utils/advancedSort";
import { Translate } from "../../I18N";


import UploadButton from "../../Metadata/components/UploadButton";
import { NeedAuthorization } from "../../Auth";
import languageLib from "../../../shared/languages";
import { ConnectedFile as File } from "./File";
import "./scss/filelist.scss";

const defaultProps = {
  files: [],
  storeKey: '',
  entity: {},
  readonly: false
};









const orderFilesByLanguage = (files, systemLanguage) => {
  const orderedFiles = [...files];
  const fileIndex = orderedFiles.findIndex((file) => {
    const language = languageLib.get(file.language, 'ISO639_1');
    return language === systemLanguage;
  });
  if (fileIndex > -1) {
    const temp = orderedFiles[fileIndex];
    [orderedFiles[fileIndex]] = orderedFiles;
    orderedFiles[0] = temp;
  }
  return orderedFiles;
};

export class FileList extends Component {
  static arrangeFiles(files = []) {
    return advancedSort(files, { property: 'originalname' });
  }



  renderFile(file, index) {
    const { entity = {} } = this.props;
    return /*#__PURE__*/(
      _jsx("li", {}, index, /*#__PURE__*/
      _jsx(File, {
        file: file,
        entity: entity,
        readonly: this.props.readonly,
        mainContext: this.props.mainContext }
      )
      ));

  }

  render() {
    const label = /*#__PURE__*/
    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Primary Documents")
    );


    const { files, storeKey, readonly, entity = {} } = this.props;
    const orderedFiles = orderFilesByLanguage(files, entity.language);
    return /*#__PURE__*/(
      _jsx("div", { className: "filelist" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "filelist-header" }, void 0,
      orderedFiles.length === 0 ? /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [entity] }, void 0,
      label
      ) : /*#__PURE__*/

      React.createElement(React.Fragment, null, label),

      !readonly && /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [entity] }, void 0, /*#__PURE__*/
      _jsx(UploadButton, { entitySharedId: entity.sharedId, storeKey: storeKey })
      )
      )

      ), /*#__PURE__*/
      _jsx("ul", {}, void 0, orderedFiles.map((file, index) => this.renderFile(file, index)))
      ));

  }
}_defineProperty(FileList, "defaultProps", defaultProps);

export default withContext(FileList);